import api from './api'

const ENDPOINT = '/admin/box-types'

const BoxTypesService = {
  /**
   * Get all box types with pagination
   * @param {Object} params - Query params { page, per_page }
   * @returns {Promise} - Paginated list of box types
   */
  async getAll(params = {}) {
    const response = await api.get(ENDPOINT, { params })
    return response.data
  },

  /**
   * Get single box type by ID
   * @param {number} id - Box type ID
   * @returns {Promise} - Box type data
   */
  async getById(id) {
    const response = await api.get(`${ENDPOINT}/${id}`)
    return response.data
  },

  /**
   * Create new box type
   * @param {Object} data - Box type data { name, note, active }
   * @returns {Promise} - Created box type
   */
  async create(data) {
    const response = await api.post(ENDPOINT, data)
    return response.data
  },

  /**
   * Update box type
   * @param {number} id - Box type ID
   * @param {Object} data - Box type data { name, note, active }
   * @returns {Promise} - Updated box type
   */
  async update(id, data) {
    const response = await api.put(`${ENDPOINT}/${id}`, data)
    return response.data
  },

  /**
   * Delete box type
   * @param {number} id - Box type ID
   * @returns {Promise} - Delete response
   */
  async delete(id) {
    const response = await api.delete(`${ENDPOINT}/${id}`)
    return response.data
  },
}

export default BoxTypesService
